import { render, staticRenderFns } from "./JournalNotes.template.vue?vue&type=template&id=b6f3657a&scoped=true&"
var script = {}
import style0 from "./JournalNotes.template.vue?vue&type=style&index=0&id=b6f3657a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f3657a",
  null
  
)

export default component.exports